import { useEffect } from 'preact/hooks';
import type { RefObject } from 'preact';

/** À l'ouverture d'un panneau, donne le focus au premier élément interactif voulu (par défaut « Retour ») pour le clavier et les lecteurs d'écran. */
export function useInitialFocus(panel: RefObject<HTMLElement>, selector: string): void {
  useEffect(() => { panel.current?.querySelector<HTMLElement>(selector)?.focus({ preventScroll: true }); }, []);
}
